import React, { useEffect } from 'react';
import './index.css';

function App() {
  useEffect(() => {
    const loadColorThief = async () => {
      const ColorThief = (await import('colorthief')).default;
      const img = document.createElement('img');
      img.src = '/ddt_logo.png';
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        const colorThief = new ColorThief();
        const color = colorThief.getColor(img);
        document.documentElement.style.setProperty('--bg-color', `rgb(${color[0]}, ${color[1]}, ${color[2]})`);
      };
    };

    loadColorThief();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center main-container">
      <main className="text-center text-white p-8 max-w-2xl">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
          <img
            src="/ddt_logo.webp"
            alt="DDT AI System Logo"
            className="logo mx-auto mb-8 w-24 h-24 rounded-full bg-white/20 p-4"
          />
          <h1 className="text-5xl font-bold mb-4">Coming Soon</h1>
          <p className="text-xl mb-8">
            Delta Digitech AI System is under construction. We're working hard to bring you an innovative AI experience.
          </p>
          <form className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="px-4 py-3 w-full sm:w-64 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300 bg-white/90"
              required
            />
            <button type="submit" className="px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg">
              Notify Me
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}

export default App;
